var _rect, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaypal = function SvgPaypal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 44
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11419 -1440)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    fill: "#f7fafa",
    "data-name": "Rechteck 15071",
    rx: 3,
    transform: "translate(-11419 1440)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1970"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "M-11397.157 1459.566a2.3 2.3 0 0 0-.649-.5 3 3 0 0 0-.494-.209l-.135-.042q-.137-.04-.284-.073t-.3-.057a7.5 7.5 0 0 0-1.178-.086h-3.571a.6.6 0 0 0-.246.056.57.57 0 0 0-.317.425l-.759 4.812-.706 4.48-.194 1.231a.342.342 0 0 0 .338.4h2.371a.57.57 0 0 0 .563-.481l.023-.121.447-2.832.029-.156a.57.57 0 0 1 .563-.481h.355c2.3 0 4.095-.933 4.62-3.631a3.09 3.09 0 0 0-.476-2.735",
    "data-name": "Pfad 1557"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 1969"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "M-11362.475 1458.62h-3.322a.46.46 0 0 0-.456.39l-1.343 8.518a.277.277 0 0 0 .273.32h1.7a.32.32 0 0 0 .319-.273l.381-2.415a.46.46 0 0 1 .456-.39h1.051a3.41 3.41 0 0 0 3.781-3.158 2.56 2.56 0 0 0-.424-2.144 3.08 3.08 0 0 0-2.416-.848m.383 3.111c-.182 1.192-1.092 1.192-1.973 1.192h-.5l.351-2.226a.28.28 0 0 1 .274-.234h.23c.6 0 1.166 0 1.458.342a1.1 1.1 0 0 1 .16.926",
    "data-name": "Pfad 1558"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M-11386.168 1458.62h-3.322a.46.46 0 0 0-.456.39l-1.343 8.518a.277.277 0 0 0 .274.32h1.586a.46.46 0 0 0 .456-.39l.362-2.3a.46.46 0 0 1 .456-.39h1.055a3.41 3.41 0 0 0 3.781-3.158 2.56 2.56 0 0 0-.424-2.144 3.08 3.08 0 0 0-2.425-.846m.383 3.111c-.182 1.192-1.092 1.192-1.973 1.192h-.5l.351-2.226a.28.28 0 0 1 .274-.234h.23c.6 0 1.166 0 1.458.342a1.1 1.1 0 0 1 .16.926",
    "data-name": "Pfad 1559"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M-11376.24 1461.693h-1.59a.28.28 0 0 0-.274.234l-.07.445-.111-.161a2.26 2.26 0 0 0-1.879-.667 3.66 3.66 0 0 0-3.551 3.2 3 3 0 0 0 .592 2.444 2.49 2.49 0 0 0 2 .809 3.05 3.05 0 0 0 2.2-.91l-.071.442a.277.277 0 0 0 .274.32h1.432a.46.46 0 0 0 .456-.389l.86-5.445a.277.277 0 0 0-.268-.322m-2.217 3.1a1.774 1.774 0 0 1-1.8 1.519 1.232 1.232 0 0 1-1.317-1.547 1.78 1.78 0 0 1 1.783-1.531 1.34 1.34 0 0 1 1.06.433 1.37 1.37 0 0 1 .274 1.122Z",
    "data-name": "Pfad 1560"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "M-11352.547 1461.693h-1.59a.28.28 0 0 0-.273.234l-.07.445-.111-.161a2.26 2.26 0 0 0-1.879-.667 3.66 3.66 0 0 0-3.551 3.2 3 3 0 0 0 .592 2.444 2.49 2.49 0 0 0 2 .809 3.05 3.05 0 0 0 2.2-.91l-.071.442a.277.277 0 0 0 .273.32h1.433a.46.46 0 0 0 .456-.389l.86-5.445a.277.277 0 0 0-.269-.322m-2.217 3.1a1.773 1.773 0 0 1-1.8 1.519 1.232 1.232 0 0 1-1.317-1.547 1.78 1.78 0 0 1 1.782-1.531 1.34 1.34 0 0 1 1.061.433 1.37 1.37 0 0 1 .274 1.122Z",
    "data-name": "Pfad 1561"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M-11367.767 1461.693h-1.6a.46.46 0 0 0-.382.2l-2.205 3.248-.935-3.121a.46.46 0 0 0-.442-.329h-1.571a.277.277 0 0 0-.262.366l1.76 5.167-1.656 2.336a.277.277 0 0 0 .226.437h1.6a.46.46 0 0 0 .379-.2l5.317-7.674a.277.277 0 0 0-.229-.43",
    "data-name": "Pfad 1562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "m-11350.673 1458.854-1.363 8.674a.277.277 0 0 0 .273.32h1.371a.46.46 0 0 0 .456-.39l1.344-8.518a.277.277 0 0 0-.273-.32h-1.534a.28.28 0 0 0-.274.234",
    "data-name": "Pfad 1563"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#003087",
    d: "M-122.805 78.105a2.91 2.91 0 0 0-.618-2.619 4.53 4.53 0 0 0-3.475-1.105h-4.556a.65.65 0 0 0-.644.55l-1.9 12.029a.39.39 0 0 0 .386.452h2.812l.706-4.48-.022.14a.65.65 0 0 1 .642-.55h1.337c2.625 0 4.681-1.067 5.281-4.151q.026-.137.047-.266",
    "data-name": "Pfad 1564",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    },
    transform: "translate(-11275.001 1380.961)"
  }))));
};
export default SvgPaypal;